import {
  BackButton,
  YearSwitch,
} from '@/domain/mitarbeiter/features/guttagekonto/components';
import { GuttagekontoCards } from '@/domain/mitarbeiter/features/guttagekonto/components/GuttagekontoCards';
import { AbwesenheitenWrapper } from '@/domain/mitarbeiter/pages/guttagekonto/AbwesenheitenWrapper';
import { LoadingPage } from '@/pages';
import { t } from 'i18next';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

export function Page() {
  return (
    <>
      <Suspense fallback={<LoadingPage />}>
        <Helmet>
          <title>{t('domain.mitarbeiter.guttagekonto.title')}</title>
        </Helmet>
        <div className="block md:hidden">
          <YearSwitch />
        </div>
        <div className="flex flex-col gap-8 py-10 px-10 ">
          <div className="flex justify-start w-auto items-center">
            <BackButton />
          </div>
          <div className="hidden md:block">
            <YearSwitch />
          </div>
          <GuttagekontoCards />
          <AbwesenheitenWrapper />
        </div>
      </Suspense>
    </>
  );
}
